export default "__VITE_ASSET__BBg8hGxt__"